import { createAsyncThunk } from '@reduxjs/toolkit';
import { sendPostRequest } from '../../../api/requestUtil';

export const getCustomerInfo = createAsyncThunk(
  'get-customer-info',
  async (fromPortal: boolean = false, { getState }) => {
    const state = getState() as AppState;
    const token = state.user.authToken;
    return sendPostRequest('/api/stripe-customer-exists/', { from_portal: fromPortal }, token);
  }
);
